export const GLOBAL_ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER_H: 'centerH',
  CENTER_V: 'centerV',
  BOTTOM: 'bottom',
  TOP: 'top',
  DISTRIBUTE_H: 'distributeH',
  DISTRIBUTE_V: 'distributeV'
};
